import { createContext } from 'react'
import { TContactsContext } from './types'

export const ContactsContext = createContext<TContactsContext>({

})